/**
 * Pure preflight for the FloorSheet Weld ID picker.
 *
 * Weld ID stays locked until Pup 1, Pup 2, and Bevel are set — but only when
 * the row has no Weld ID yet. Rows with an existing Weld ID remain editable.
 */

import type { FloorSheetParametersPupKey } from './floorSheetParametersPreflight'

export type FloorSheetWeldIdPreflightInput = {
  weldId: string
  pupOne: string
  pupTwo: string
  bevelIndex: number | null
}

export type FloorSheetWeldIdPreflightOutcome =
  | { kind: 'allowed' }
  | { kind: 'missing-pup'; pup: FloorSheetParametersPupKey }
  | { kind: 'missing-bevel' }

export function evaluateFloorSheetWeldIdPreflight(
  input: FloorSheetWeldIdPreflightInput
): FloorSheetWeldIdPreflightOutcome {
  if (input.weldId.trim()) {
    return { kind: 'allowed' }
  }
  if (!input.pupOne.trim()) {
    return { kind: 'missing-pup', pup: 'pupOne' }
  }
  if (!input.pupTwo.trim()) {
    return { kind: 'missing-pup', pup: 'pupTwo' }
  }
  if (input.bevelIndex === null) {
    return { kind: 'missing-bevel' }
  }
  return { kind: 'allowed' }
}
